import React, { useState } from 'react';
import { View, Text, TouchableOpacity, TextInput } from 'react-native';

import CidadesComponent from '../../components/CidadesComponent';
import api from '../../services/api';
import isEmail from '../../utils/isValidEmail';

const CriarGerente = ({ navigation }) => {
  const [nome, setNome] = useState('');
  const [email, setEmail] = useState('');
  const [cidade, setCidade] = useState(null);

  const handleSubmit = () => {
    if (!nome.length) {
      return alert('Nome deve conter pelo menos 1 digito');
    }

    if (!isEmail(email)) {
      return alert('E-mail invalido.');
    }

    if (!cidade) {
      return alert('Selecione uma cidade.');
    }

    api
      .post('gerentes', {
        nome,
        email,
        cidade,
      })
      .then(() => {
        alert('Cadastro realizado com sucesso');
        navigation.goBack();
      })
      .catch((e) => {
        if (e.response.data.msg) {
          alert(e.response.data.msg);
        } else {
          alert(
            'Falha ao cadastrar o gerente, por favor verifique todos os campos'
          );
        }
      });
  };

  const handleChangeCidade = (cidade) => {
    setCidade(cidade);
  };

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, flex: 1 }}>
        <View
          style={{
            backgroundColor: '#fff',
            padding: 10,
            marginTop: 10,
            borderRadius: 5,
          }}
        >
          <Text style={{ fontSize: 12 }}>Nome do gerente</Text>
          <TextInput
            onChangeText={setNome}
            value={nome}
            style={{
              paddingTop: 5,
              marginTop: 5,
              paddingBottom: 5,
              paddingLeft: 5,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 5,
            }}
          />

          <Text style={{ fontSize: 12, marginTop: 10 }}>Email</Text>
          <TextInput
            onChangeText={(e) => setEmail(e.toLowerCase())}
            value={email}
            style={{
              paddingTop: 5,
              marginTop: 5,
              paddingBottom: 5,
              paddingLeft: 5,
              borderWidth: 1,
              borderColor: '#000',
              borderRadius: 5,
            }}
          />
          <Text style={{ fontSize: 12, marginTop: 10 }}>
            A senha padrao para novos usuarios é 123456
          </Text>

          <Text style={{ fontSize: 12, marginTop: 10 }}>Cidade</Text>
          <CidadesComponent value={cidade} handleChange={handleChangeCidade} />
        </View>

        <View style={{ display: 'flex', flexDirection: 'row', marginTop: 25 }}>
          <TouchableOpacity
            onPress={handleSubmit}
            style={{ flex: 1, marginLeft: 5 }}
          >
            <Text
              style={{
                padding: 5,
                textAlign: 'center',
                backgroundColor: '#1abc9c',
                color: '#fff',
                borderRadius: 5,
              }}
            >
              Salvar
            </Text>
          </TouchableOpacity>
        </View>
      </View>
    </View>
  );
};

export default CriarGerente;
